import create, { UseStore } from 'zustand';

type Status = {
  status: string;
  setStatus(value: string): void;
};

export type StatusApi = UseStore<Status>;
export function createStatusApi(status = null): StatusApi {
  return create<Status>((set) => ({
    status,
    setStatus: (status) => set({ status }),
  }));
}

export interface WithStatus {
  status?: StatusApi;
}
